exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".event .event-actions {\n  position: relative;\n}\n.event .event-actions .preloader {\n  top: 0;\n  left: 25%;\n}\n.event .event-actions .saved {\n  color: red;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/less-loader/dist/cjs.js??ref--1-oneOf-3-2!./src/components/Modules/Info/Icons/Icons.less
// module id = 1322
// module chunks = 0